import { render } from "./MerchantTransactions.vue?vue&type=template&id=01ee44b5&scoped=true"
import script from "./MerchantTransactions.vue?vue&type=script&lang=js"
export * from "./MerchantTransactions.vue?vue&type=script&lang=js"

import "./MerchantTransactions.vue?vue&type=style&index=0&id=01ee44b5&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ee44b5"]])

export default __exports__